// @generated by protoc-gen-connect-query v1.4.1 with parameter "target=ts"
// @generated from file no/jotta/openapi/business/v1/business.proto (package no.jotta.openapi.business.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { MethodKind } from "@bufbuild/protobuf";
import { CreateBusinessUserRequest, CreateBusinessUserResponse, ListUsersRequest, ListUsersResponse, PatchBusinessRequest, PatchBusinessResponse, PatchBusinessUserRequest, PatchBusinessUserResponse, RemoveBusinessUserRequest, RemoveBusinessUserResponse, TerminateBusinessRequest, TerminateBusinessResponse } from "./business_pb.js";
import { PingRequest, PingResponse } from "../../ping_pb.js";
/**
 * @generated from rpc no.jotta.openapi.business.v1.BusinessService.ListUsers
 */
export const listUsers = {
    localName: "listUsers",
    name: "ListUsers",
    kind: MethodKind.Unary,
    I: ListUsersRequest,
    O: ListUsersResponse,
    service: {
        typeName: "no.jotta.openapi.business.v1.BusinessService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.business.v1.BusinessService.PatchBusiness
 */
export const patchBusiness = {
    localName: "patchBusiness",
    name: "PatchBusiness",
    kind: MethodKind.Unary,
    I: PatchBusinessRequest,
    O: PatchBusinessResponse,
    service: {
        typeName: "no.jotta.openapi.business.v1.BusinessService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.business.v1.BusinessService.CreateBusinessUser
 */
export const createBusinessUser = {
    localName: "createBusinessUser",
    name: "CreateBusinessUser",
    kind: MethodKind.Unary,
    I: CreateBusinessUserRequest,
    O: CreateBusinessUserResponse,
    service: {
        typeName: "no.jotta.openapi.business.v1.BusinessService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.business.v1.BusinessService.PatchBusinessUser
 */
export const patchBusinessUser = {
    localName: "patchBusinessUser",
    name: "PatchBusinessUser",
    kind: MethodKind.Unary,
    I: PatchBusinessUserRequest,
    O: PatchBusinessUserResponse,
    service: {
        typeName: "no.jotta.openapi.business.v1.BusinessService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.business.v1.BusinessService.RemoveBusinessUser
 */
export const removeBusinessUser = {
    localName: "removeBusinessUser",
    name: "RemoveBusinessUser",
    kind: MethodKind.Unary,
    I: RemoveBusinessUserRequest,
    O: RemoveBusinessUserResponse,
    service: {
        typeName: "no.jotta.openapi.business.v1.BusinessService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.business.v1.BusinessService.TerminateBusiness
 */
export const terminateBusiness = {
    localName: "terminateBusiness",
    name: "TerminateBusiness",
    kind: MethodKind.Unary,
    I: TerminateBusinessRequest,
    O: TerminateBusinessResponse,
    service: {
        typeName: "no.jotta.openapi.business.v1.BusinessService"
    }
};
/**
 * Safe noop for testing purposes
 *
 * @generated from rpc no.jotta.openapi.business.v1.BusinessService.Ping
 */
export const ping = {
    localName: "ping",
    name: "Ping",
    kind: MethodKind.Unary,
    I: PingRequest,
    O: PingResponse,
    service: {
        typeName: "no.jotta.openapi.business.v1.BusinessService"
    }
};
